import { render, staticRenderFns } from "./EinstellungenDebitor.vue?vue&type=template&id=9552d4ec&"
import script from "./EinstellungenDebitor.vue?vue&type=script&lang=js&"
export * from "./EinstellungenDebitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports